import React from 'react';

export const PropertyListLoadingCard: React.FC = () => (
  <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm">
    <div className="grid grid-cols-1 gap-0 lg:grid-cols-[200px_minmax(0,1fr)] xl:grid-cols-[220px_minmax(0,1fr)]">
      <div className="aspect-[16/11] animate-pulse bg-slate-200" />
      <div className="space-y-4 p-4 sm:p-5">
        <div className="h-4 w-28 animate-pulse rounded-full bg-slate-200" />
        <div className="h-8 w-2/3 animate-pulse rounded-xl bg-slate-200" />
        <div className="h-5 w-1/2 animate-pulse rounded-xl bg-slate-100" />
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="h-10 w-28 animate-pulse rounded-full bg-slate-100"
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);
